// Typelizer digest 79180e63f49e626e6bdb729fd8271b4a
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /signup */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/signup', {}, options),
    method: 'get',
  }),

  /** POST /users */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/users', {}, options),
    method: 'post',
  }),
}
